import React from 'react';
import Navabars from '../Navbar/Navabars';

const Header = () => {
    return (
        <div>
            <Navabars/>
        </div>
    );
};

export default Header;